











import {ChartDataTemplate, FCConfTpl, FusionDisplayConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import {bus} from '@/main'
import {defineComponent, reactive} from "@vue/composition-api"
import {datePeriodStartDate, getTodayYYYYMMDD, toYYYYMMDD} from "@/data/sources/dates"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {executeQuery} from "@/data/repos/query"

export function config(): WidgetDefinition {
    return {
      ...WConfTpl.KeyValue(),
      widget: "AuditRoomStatus",
      title: "Audited room status",
      _description: "Audit room status",
      params: {
        auditCategory: {...WParamTpl.auditCategory(), _order: 1},
      },
      fusionChartParams: {
        numberFormatting: {...FusionDisplayConfTpl.numberFormatting()},
      },
    }
  }

  function getChartConfig() {
    return reactive(FCConfTpl())
  }

  function getChartDataConfig() {
    return reactive({
        ...ChartDataTemplate(),
        paletteColors: "#6baa01, #DC143C, #FFBF00",
        showZeroPies: "1",
        showPercentValues: "1",
        showPercentInTooltip: "1",
        animation: "0",
      },
    )
  }

  async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
    if (config) {
      chartDataConfig.subCaption = "Category: " + (config.params.auditCategory.value.title || "<All>")
    }
  }

  export default defineComponent({
    props: {
      config: {type: Object, required: true},
    },
    components: {
      FusionChartWidget,
    },
    setup(props, context) {
      context.emit("config-update", config())
      const fromDate = toYYYYMMDD(datePeriodStartDate(new Date(), "ytd"))
      const toDate = getTodayYYYYMMDD()

      async function dataFetcher(params: any): Promise<{ data: any[] }> {
        // @fromDate smalldatetime, @toDate smalldatetime,
        // @auditTemplateID bigint = 0, @riskID AS bigint = 0, @functionalAreaID bigint = 0, @auditPurposeID bigint = 0,
        // @teamID bigint = 0, @responsibleGroupID bigint = 0, @departmentID bigint = 0, @elementTypeID bigint = 0
        const categoryID = params.auditCategory.value.value || 0
        return {
          data: await executeQuery(
            "micad4-audit", "auditRoomStatus",
            {fromDate, toDate, categoryID}), // todo pass all parameters
        }
      }

      function dataplotClickCallback(label: string, val: any) {
        if (val === undefined) {
          return
        }
        let auditType
        if (label == 'Rooms not audited') {
          auditType = 1
        } else if (label == 'Rooms audited') {
          auditType = 2
        } else if (label == 'Rooms with no access') {
          auditType = 3
        }
        bus.$emit("chartPopup", {
          title: "Audited room status: " + label + " (" + val + ")",
          component: () => import('@/components/widgets/audit/AuditAuditedRoomsStatusDrillDown.vue'),
          componentArgs: {
            fromDate: fromDate,
            toDate: toDate,
            auditType: auditType,
            categoryID: props.config.params.auditCategory.value.value,
          },
        })
      }

      return {dataFetcher, getChartDataConfig, dataplotClickCallback, configChangeCallback}
    },
  })
